import { CloseQuoteBold, OpenQuoteBold } from '@ha/icons';
import React from 'react';
import cx from 'classnames';
import { withStyles, WithStyles, createStyles } from '@material-ui/core';

const styles = createStyles({
  blockquote: {
    '& .md__p': {
      flexGrow: 1,
    },
  },
});

const BlogLandingBlockquoteInternal: React.FC<WithStyles<typeof styles>> = ({
  children,
  classes,
}) => (
  <blockquote
    className={cx(
      'blog-landing--blockquote text-center m-y-3 flexbox line-height-twice',
      classes.blockquote,
    )}
  >
    <OpenQuoteBold
      className="relative font-size-xl opacity-0_3 blog-landing--quote-left align-self-start"
      color="secondary"
    />
    {children}
    <CloseQuoteBold
      className="relative font-size-xl opacity-0_3 blog-landing--quote-right align-self-flex-end"
      color="secondary"
    />
  </blockquote>
);

const BlogLandingBlockquote = withStyles(styles)(BlogLandingBlockquoteInternal);
export { BlogLandingBlockquote };
